import { z } from 'zod';
import { Option, pipe } from 'effect';

// The operators the custom date filter offers, in the order its condition picker lists them. A model reaches the
// filter from outside (the grid, a saved preset, the browser), so its `type` is parsed with this schema where it is
// read, never trusted as one of these names.
export const DateFilterOperatorSchema = z.enum(['beforeOrOn', 'afterOrOn', 'inRange', 'withInMonth', 'withInYear']);
export type DateFilterOperator = z.infer<typeof DateFilterOperatorSchema>;

export const DATE_FILTER_OPERATORS = DateFilterOperatorSchema.options;

export const parseDateFilterOperator = (value: unknown): Option.Option<DateFilterOperator> =>
  pipe(DateFilterOperatorSchema.safeParse(value).data, Option.fromNullable);
